import React, { Component } from 'react'
import PropTypes from 'prop-types'
import './MessageForm.css'
import { MdSend } from 'react-icons/lib/md'

class MessageForm extends Component {
  static propTypes = {
    onMessageSend: PropTypes.func.isRequired,
    onTyping: PropTypes.func,
    onInputFocus: PropTypes.func
  }

  componentDidMount = () => {
    this.input.focus()
  }

  handleInputChange = (event) => {
    // Call typing callback if provided
    if (this.props.onTyping && event.target.value.length > 0) {
      this.props.onTyping();
    }
  }

  handleFormSubmit = (event) => {
    event.preventDefault()
    if (this.input.value && this.input.value.trim().length > 0) {
      this.props.onMessageSend(this.input.value.trim())
    }
    this.input.value = ""
  }

  onFocus = () => {
    this.props.onInputFocus();
  }

  render() {
    return (
      <form className="MessageForm" onSubmit={this.handleFormSubmit}>
        <div className="input-container">
          <input
            type="text"
            ref={(node) => (this.input = node)}
            placeholder="Enter your message..."
            style={{fontSize: "16px"}}
            onChange={this.handleInputChange}
            onFocus={this.onFocus}
          />
        </div>
        <div className="button-container">
          <button type="submit" style={{height: "100%"}}>
            <MdSend size="20px"/>
          </button>
        </div>
      </form>
    )
  }
}

export default MessageForm
